module.exports = __webpack_public_path__ + "static/media/search.c45e0c2b.svg";